// extracted by mini-css-extract-plugin
export default {"root":"TariffButton__root--1LQxr","text":"TariffButton__text--3W_Sv","subtext":"TariffButton__subtext--1-Gpx"};